module.exports = __webpack_public_path__ + "static/img/aboutUS_lyzwzzl.446f854.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img1/aboutUS_lyzwzzl.png
// module id = XvFB
// module chunks = 1